import { proficiencyDotClasses } from '@/lib/profile-evidence-display'
import { cn } from '@/lib/utils'

export function ProficiencyLabelBadge({
  label,
  className,
}: {
  label: string
  className?: string
}) {
  return (
    <span className={cn('inline-flex shrink-0 items-center gap-1.5 text-xs', className)}>
      <span
        className={cn('size-1.5 shrink-0 rounded-full', proficiencyDotClasses(label))}
        aria-hidden
      />
      <span className="font-normal text-muted-foreground">{label}</span>
    </span>
  )
}
